import { createRoot } from "react-dom/client";
import { QuoteForm } from "../../islands/QuoteForm.js";

const el = document.querySelector<HTMLElement>('[data-island="quote-form"]');
if (el) {
  const props = JSON.parse(el.getAttribute("data-props") || "{}");
  createRoot(el).render(<QuoteForm {...props} />);
}
